import { AdminPanelLabel } from "../components/TopicsPanel/types";
import { protectedResources } from "../context/AuthContext/authConfig";
import { UserWithTopics } from "../context/ConfigContext/types";
import { NewsletterRequest, UserFeedback } from "../types";
import {
	CreateOrUpdateConfigBody,
	CreateLabelValueBody,
	CreateOrUpdateOptionValue,
	Endpoint,
	FetchResponse,
	CreateMainUserResponse,
} from "./types";
import { apiRequest } from "./helpers";
import { RequestType } from "./types";
import { UserWithClients } from "../context/ClientAccessContext/types";
import axios from "axios";

export const createUserFeedback = async (reqBody: UserFeedback) => {
	const url = protectedResources.scraperAPI.endpoint + Endpoint.USER_FEEDBACK;
	return apiRequest(RequestType.POST, url, reqBody) as Promise<
		FetchResponse<any>
	>;
};

export const createPossibleLabelValue = async (
	reqBody: CreateLabelValueBody
) => {
	const url = protectedResources.scraperAPI.endpoint + Endpoint.LABEL_VALUES;
	return apiRequest(RequestType.POST, url, reqBody) as Promise<
		FetchResponse<any>
	>;
};

export const createTopic = async (reqBody: string) => {
	const url = protectedResources.scraperAPI.endpoint + Endpoint.TOPICS;
	return apiRequest(RequestType.POST, url, { name: reqBody }) as Promise<
		FetchResponse<number>
	>;
};

export const createOrUpdateLabel = async (reqBody: AdminPanelLabel) => {
	const url = protectedResources.scraperAPI.endpoint + Endpoint.LABELS;
	return apiRequest(RequestType.POST, url, reqBody) as Promise<
		FetchResponse<number>
	>;
};

export const createClientUser = async (reqBody: UserWithTopics) => {
	const url = protectedResources.scraperAPI.endpoint + Endpoint.CLIENT_USERS;
	return apiRequest(RequestType.POST, url, reqBody) as Promise<
		FetchResponse<UserWithTopics>
	>;
};

export const createMainUser = async (reqBody: UserWithClients) => {
	const url = protectedResources.scraperAPI.endpoint + Endpoint.MAIN_USERS;
	return apiRequest(RequestType.POST, url, reqBody) as Promise<
		FetchResponse<CreateMainUserResponse>
	>;
};

export const createConfigOptionValue = async (
	reqBody: CreateOrUpdateOptionValue
) => {
	const url =
		protectedResources.scraperAPI.endpoint + Endpoint.CONFIG_OPTION_VALUE;
	return apiRequest(RequestType.POST, url, reqBody) as Promise<
		FetchResponse<number>
	>;
};

export const createConfig = async (reqBody: CreateOrUpdateConfigBody) => {
	const url = protectedResources.scraperAPI.endpoint + Endpoint.CONFIG;
	return apiRequest(RequestType.POST, url, reqBody) as Promise<
		FetchResponse<number>
	>;
};

export const sendNewsletter = async (reqBody: NewsletterRequest) => {
	const url = protectedResources.scraperAPI.endpoint + Endpoint.SEND_NEWSLETTER;
	return axios.post<number>(url, reqBody);
};
